import CompanyRoutes from '../apiRoutes/CompanyRoutes';
import { GET, POST } from './ConsumeApiController';

export async function GetAppUser(app_id)
{
    let response = await GET(CompanyRoutes.Apps.GetAppUser+app_id);
    return response;
}